import * as React from 'react';
import { Numberbox } from 'ui';
import { ExternalUrlGroupsTranslation } from 'app/area/external-url-groups/constants';
import { ExternalUrlFormIds } from 'app/area/external-url-groups/form/constants';
import { ValidationProps } from 'ui/common/validation';

interface ExternalUrlGroupSequenceProps {
  value: number;
  readOnly: boolean;
  locale: string;
  validation: ValidationProps;
  translation: ExternalUrlGroupsTranslation;
  onChange: (sequence: number) => void;
}

export const ExternalUrlGroupSequence = ({
  value, readOnly, locale, validation, translation, onChange
}: ExternalUrlGroupSequenceProps) =>
  <Numberbox
    className={undefined}
    label={{ text: translation.sequence }}
    componentId={ExternalUrlFormIds.sequence}
    onChange={onChange}
    value={value}
    validation={validation}
    readOnly={readOnly}
    locale={locale} />;
